import React from "react";
import * as styles from "./Features.module.scss";
import WhiteUprightArrow from "../../../../icons/arrows/white-upright-arrow.svg";
import Button from "../../../UI/Button/Button";
import { Link, navigate } from "gatsby";

const Features = ({
  characteristics,
  colors,
  current,
  manual,
  recipesbook,
  colorCategory,
  link,
}) => {
  function createMarkup(htmlString) {
    return { __html: htmlString };
  }


  // Handler for the "Ver manual" button
  const onManualClick = () => {
    window.open(manual, "_blank");
  };

  // Handler for the "Ver manual" button
  const onRecipesbookClick = () => {
    window.open(recipesbook, "_blank");
  };

  const onBuy = () => {
    window.open(link, "_blank");
  };

  return (
    <div className={styles.features__container}>
      <div className={styles.features__center}>
        <div className={styles.mobile}>
          <p>
            Colores:
          </p>
          {colors?.map((e) => {
            const isSelected = current === e.slug;
            const linkStyle = {
              backgroundColor: e.color,
              border: isSelected ? "1px solid black" : "none",
            };
            return (
              <Link
                to={`/detalle/${e.slug}`}
                className={styles.colors}
                style={linkStyle}
              />
            );
          })}
        </div>
        <h3 className={styles.features__title}>Características</h3>

        <div className={styles.container_text}>
          <div dangerouslySetInnerHTML={createMarkup(characteristics)} />
        </div>

        <div className={styles.container_colors}>
          <div>
            <p>Colores:</p>
          </div>
          {colors?.map((e) => {
            const isSelected = current === e.slug;
            const linkStyle = {
              backgroundColor: e.color,
              border: isSelected ? "1px solid blue" : "1px solid black",
            };
            return (
              <Link
                to={`/detalle/${e.slug}`}
                className={styles.colors}
                style={linkStyle}
              />
            );
          })}
        </div>

        <div className={styles.features__buttons}>
          <div>
            {manual && (
              <Button
                border={true}
                text="Ver manual"
                color={colorCategory}
                onClick={onManualClick}
              />
            )}
          </div>
          <div>
            {recipesbook && (
              <Button
                border={true}
                text="Ver Recetario"
                color={colorCategory}
                onClick={onRecipesbookClick}
              />
            )}
          </div>
          <div>
            {link && (
              <Button
                text="Comprar"
                color={colorCategory}
                icon={WhiteUprightArrow}
                onClick={onBuy}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Features;
